const OrgAdmin = 'OrgAdmin';
const OrgUser = 'OrgUser';
const Trainer = 'Trainer';
const Official = 'Official';
const Statistiker = 'Statistiker';
const Approver = 'Approver';

export default {
	OrgAdmin,
	OrgUser,
	Trainer,
	Official,
	Statistiker,
	Approver,
};
